function normalizeData(data) {
    if (data.length === 0) {
        return [];
    }
    // Преобразуем каждый элемент в нижний регистр, потом убираем дубликаты и сортируем
    const lowercasedData = data.map(item => String(item).toLowerCase());
    return [...new Set(lowercasedData)].sort();
}

export default normalizeData;